import AttentionStrip from "./AttentionStrip";
import ContextualHero from "./ContextualHero";
import NextActionCard from "./NextActionCard";
import PhaseProgress from "./PhaseProgress";
import styles from "./guidance.module.css";

/**
 * Standard organizer guidance surface.
 * Composes engine output only — never computes phase or actions.
 *
 * Layout: Hero → PhaseProgress → NextActionCard → AttentionStrip
 *
 * @param {{
 *   guidance?: object | null,
 *   onAction?: (action: object) => void,
 *   onAttention?: (item: object) => void,
 *   primaryLoading?: boolean,
 *   className?: string,
 * }} props
 */
export default function GuidanceContainer({
  guidance,
  onAction,
  onAttention,
  primaryLoading = false,
  className,
}) {
  if (!guidance) return null;

  return (
    <div
      className={[styles.surface, className].filter(Boolean).join(" ")}
      data-testid="guidance-container"
      data-phase={guidance.phase?.id || undefined}
      data-urgency={guidance.urgency || undefined}
    >
      <ContextualHero hero={guidance.hero} />
      <PhaseProgress progress={guidance.progress} />
      <NextActionCard
        primaryAction={guidance.primaryAction}
        secondaryActions={guidance.secondaryActions}
        onAction={onAction}
        primaryLoading={primaryLoading}
      />
      <AttentionStrip attention={guidance.attention} onAttention={onAttention} />
    </div>
  );
}
